import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currency", "interval", "warning"]
  static values = { warnings: Object, confirmation: String }

  connect() {
    this.update()
  }

  update() {
    const warning = this.warningsValue[`${this.currencyTarget.value}:${this.intervalTarget.value}`]
    this.warningTarget.textContent = warning || ""
    this.warningTarget.hidden = !warning

    // Let Turbo handle cancellation before it sends the form.
    if (warning) {
      this.element.dataset.turboConfirm = `${warning}\n\n${this.confirmationValue}`
    } else {
      delete this.element.dataset.turboConfirm
    }
  }
}
